import AdItem from '@/app/service/api/model/ad/ad-item-type/ad-item'
import { mapState } from 'vuex'

export default {
  props: {
    media: {
      type: AdItem,
      required: true
    }
  },
  computed: {
    ...mapState({
      baseUrl: state => state.playlist.adItems.baseUrl
    })
  },
  methods: {
    getUrl (media) {
      if (media.isExternalSource()) {
        return media.getUrl()
      }
      return this.baseUrl + media.getFile().getPath()
    },
    ended () {
      this.$emit('ended')
    },
    error () {
      this.$emit('error')
    },
    successLoad () {
      this.$emit('success')
    }
  }
}
